import { configureStore } from "@reduxjs/toolkit";
import CartSlice from "./slices/CartSlice";
import CompareSlice from "./slices/CompareSlice";
import WishSlice from "./slices/WishSlice";

const Store = configureStore({
   reducer: {
      cart: CartSlice,
      compare: CompareSlice,
      wish:WishSlice
   },
});
export default Store;
 